@if ((filteredList$ | async)?.length === 0) {
  <div class="empty-state__container mod-large-padding">
    <div class="pb-20">
      {{ "infinite_scroll_try_again_full" | translate }}
    </div>
    <button class="btn btn-primary" (click)="refetchData.emit()">
      <strong>{{ "infinite_scroll_try_again_button" | translate }}</strong>
    </button>
  </div>
} @else {
  <div class="empty-state__container">
    {{ "infinite_scroll_try_again_1" | translate }}
    <a (click)="refetchData.emit()">{{ "infinite_scroll_try_again_2" | translate }}</a>
    {{ "infinite_scroll_try_again_3" | translate }}
  </div>
}
